import React from "react";
import Joi from "joi-browser";
import Button from "react-bootstrap/Button";
import Form from "./common/form";

class ModelsForm extends Form {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
    };
  }

  schema = {
    manufacturer_id: Joi.number()
      .label("Brand")
      .min(1)
      .required()
      .options({
        language: {
          number: { min: " cannot be empty!" },
        },
      }),
    media_id: Joi.number()
      .label("Model Media")
      .min(1)
      .required()
      .options({
        language: {
          number: { min: " cannot be empty!" },
        },
      }),
    scale_id: Joi.number()
      .label("Scale Range")
      .min(1)
      .required()
      .options({
        language: {
          number: { min: " cannot be empty!" },
        },
      }),
    kit_mold: Joi.string().label("Kit Mold").max(100).optional().allow(""),
    kit_no: Joi.string().label("Kit No.").max(100).optional().allow(""),
  };

  async componentDidMount() {}

  handleClear = () => {
    this.props.onClearForm();
  };

  doSubmit() {
    this.props.onFormSubmit();
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <table className="modelsFormTable">
          <tbody>
            <tr>
              <td>
                {this.renderSelect(
                  "manufacturer_id",
                  "Brand",
                  this.props.manufacturers,
                  "manufacturer_id",
                  "manufacturer_name",
                  "tools"
                )}
              </td>
              <td>
                {this.renderSelect(
                  "media_id",
                  "Model Media",
                  this.props.media,
                  "media_id",
                  "media_name",
                  "dna"
                )}
              </td>
              <td>
                {this.renderSelect(
                  "scale_id",
                  "Scale Range",
                  this.props.scales,
                  "scale_id",
                  "scale_range",
                  "balance-scale-right"
                )}
              </td>
              <td width="180px">
                {this.renderInput("kit_mold", "Kit Mold", "hard-hat")}
              </td>
              <td width="140px">
                {this.renderInput("kit_no", "Kit No.", "hashtag")}
              </td>
            </tr>
            <tr>
              <td colSpan="5">
                <button className="btn btn-primary">Add</button>&nbsp;
                <Button variant="primary" onClick={() => this.handleClear()}>
                  Clear
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    );
  }
}

export default ModelsForm;
